import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { post, put } from '../../utils/api';
import { Form, FormLine, FormItem, FormInput } from '../common/Form';
const LIMIT = 150;
//
// Компонент для создания и редактирования файла
//
const ExhibitorEditFile = () => {
	const { t } = useTranslation();
    const { id } = useParams(); // в качестве id используем имя файла, оно уникально
	const navigate = useNavigate();
    const exhibitor = useSelector(state => state.exhibitor);
	const [ nameRu, setNameRu ] = useState('');
	const [ nameEn, setNameEn ] = useState('');
    const [ descrRu, setDescrRu ] = useState('');
    const [ descrEn, setDescrEn ] = useState('');
    const [ file, setFile ] = useState(null);
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ error, setError ] = useState('');

    // Начальные значения
    useEffect(() => {
        if(!id || !exhibitor) return;
        const file = exhibitor.files.find(f => f.file === id);
        if(!file) return;
        setNameRu(file.name.ru);
        setNameEn(file.name.en);
        if(file.descr) {
            setDescrRu(file.descr.ru);
            setDescrEn(file.descr.en);
        }
    }, [ id, exhibitor ]);

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setError('');
        setSuccess('');

        const formData = new FormData();
        if(id) {
            formData.append('file', id);
        } else {
            formData.append('file', file, file.name);
        }
        formData.append('exhibitor', exhibitor._id);
        formData.append('name_ru', nameRu);
        formData.append('name_en', nameEn);
        formData.append('descr_ru', descrRu);
        formData.append('descr_en', descrEn);

        let result;
        if(id) {
            result = await put('/file', formData);
        } else {
            result = await post('/file', formData);
        }

        if(result.error) {
            setError(result.error);
        } else {
            setSuccess(id ? 'file.success_edit' : 'file.success_add');
			navigate('/cabinet/exhibitorview/' + exhibitor._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{id ? t('file.title_edit') : t('file.title_add')}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={error}
                info={id ? 'file.subtitle_edit' : 'file.subtitle_add'}
                wide={true}
                submit={id ? t('file.submit_edit') : t('file.submit_add')}
                onSubmit={onSubmit}
            >
                {/* Название */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='nameRu'
                            type='text'
                            value={nameRu}
                            onChange={setNameRu}
                            placeholder={t('file.name_ru')}
                            className='lang-ru'
                            required={true}
                            label={t('file.name_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='nameEn'
                            type='text'
                            value={nameEn}
                            onChange={setNameEn}
                            placeholder={t('file.name_en')}
                            className='lang-en'
                            required={true}
                            label={t('file.name_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Описание */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='descrRu'
                            type='textarea'
                            limit={LIMIT}
                            value={descrRu}
                            onChange={setDescrRu}
                            placeholder={t('file.descr_ru')}
                            className='lang-ru'
                            label={t('file.descr_ru')}
                            hint={(descrRu ? descrRu.length + ' / ' : 'Max: ') + LIMIT}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='descrEn'
                            type='textarea'
                            limit={LIMIT}
                            value={descrEn}
                            onChange={setDescrEn}
                            placeholder={t('file.descr_en')}
                            className='lang-en'
                            label={t('file.descr_en')}
                            hint={(descrEn ? descrEn.length + ' / ' : 'Max: ') + LIMIT}
                        />
                    </FormItem>
                </FormLine>
                {/* Файл */}
                {!id &&
                <FormInput
                    id='file'
                    type='file'
                    accept='application/pdf'
                    value={file ? file.name : ''}
                    onChange={setFile}
                    label={t('file.file')}
                    hint={t('file.file_hint')}
                    required={true}
                />}
			</Form>}

            <NavLink to={'/cabinet/exhibitorview/' + exhibitor._id}>
                {id ? t('file.back_edit') : t('file.back_add')}
            </NavLink>
		</div>
	);
};

export default ExhibitorEditFile;
